import React from 'react';
import styled from 'styled-components';
import * as JStorage from 'rev.sdk.js/Actions/JStorage';
import * as AppActions from '../../AppActions';
import NavLink from '../../Components/NavLink';
import {mapLineBreak} from '../../Utils/TextUtil';

function mapFakeItem() {
  return [0, 1, 2, 3, 4].map((ele) => (
    <div>
      <img alt="" src="" style={{height: 0}} />
    </div>
  ));
}

export default function CreatorList(props) {
  const [creators, setCreators] = React.useState([]);

  React.useEffect(() => {
    async function fetchData() {
      AppActions.setLoading(true);
      try {
        setCreators(
          await JStorage.fetchAllDocuments('creator', {public: true}),
        );
      } catch (ex) {
        console.warn('CreatorList.useEffect ex', ex);
      }
      AppActions.setLoading(false);
    }

    fetchData();
  }, []);

  return (
    <Wrapper>
      <div className="container">
        <div className="title-container">
          <h2>創作者</h2>
          <h3>Creator</h3>
        </div>

        <div className="creator-container">
          {creators.map((creator) => {
            return (
              <NavLink key={creator.id} to={`/creator/${creator.path}/`}>
                <img src={creator.image} alt="creator-item" />
                <div className="info">
                  <h2 className="name">{creator.name}</h2>
                  <div
                    className="description"
                    dangerouslySetInnerHTML={{
                      __html: mapLineBreak(creator.description || ''),
                    }}
                  />
                </div>
              </NavLink>
            );
          })}

          {mapFakeItem()}
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  min-height: var(--contentMinHeight);
  padding-top: var(--topNavBarHeight);

  & > .container {
    max-width: var(--contentMaxWidth);
    margin: 0 auto;
    padding: 50px 30px;

    & > .title-container {
      margin-left: 10px;
      margin-bottom: 30px;

      & > h2 {
        font-weight: bold;
        font-size: 1.4rem;
        color: var(--primaryColor);
      }

      & > h3 {
        font-size: 1.25rem;
        color: var(--primaryColor);
      }
    }

    // max-width 1140px
    & > .creator-container {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      & > * {
        margin: 10px;
        cursor: pointer;

        & > img {
          width: 265px;
          height: 265px;
          object-fit: cover;
        }

        & > .info {
          width: 265px;
          padding: 15px 0px;

          & > .name {
            margin-bottom: 14px;
            height: 100px;
            overflow: hidden;
          }

          & > .description {
            height: 44px;
            color: #aeb6b8;
            overflow: hidden;
          }
        }
      }
    }

    // (265 + 20) * 4 = 1140 + 60 padding = 1200
    @media screen and (max-width: ${1200 - 1}px) {
      & > .creator-container > * > img {
        width: 235px;
        height: 235px;
      }

      &  > .creator-container > * > .info {
        height: 235px;
      }
    }

    // (235 + 20) * 4 = 1060 + 60 padding = 1120
    @media screen and (max-width: ${1120 - 1}px) {
      & > .creator-container > * > img {
        width: 215px;
        height: 215px;
      }

      &  > .creator-container > * > .info {
        height: 215px;
      }
    }

    // (215 + 20) * 4 = 860 + 60 padding = 920
    @media screen and (max-width: ${1000 - 1}px) {
      & > .creator-container > * > img {
        width: 195px;
        height: 195px;
       }

       &  > .creator-container > * > .info {
        width: 195px;
      }
    }

    // (195 + 20) * 4 = 860 + 60 padding = 920
    @media screen and (max-width: ${920 - 1}px) {
      & > .creator-container > * > img {
        width: 265px;
        height: 265px;
      }

      &  > .creator-container > * > .info {
        width: 265px;
      }
    }

    // (265 + 20) * 3 = 855 + 60 = 915
    @media screen and (max-width: ${915 - 1}px) {
      & > .creator-container > * > img {
        width: 255px;
        height: 255px;
      }

      &  > .creator-container > * > .info {
        width: 255px;
      }
    }

    // (255 + 20) * 3 = 825 + 60 = 885
    @media screen and (max-width: ${885 - 1}px) {
      & > .creator-container > * > img {
        width: 235px;
        height: 235px;
      }
    
      &  > .creator-container > * > .info {
        width: 235px;
      }
    }

    // (235 + 20) * 3 = 765 + 60 = 825
    @media screen and (max-width: ${825 - 1}px) {
      & > .creator-container > * > img {
        width: 215px;
        height: 215px;
      }

      &  > .creator-container > * > .info {
        width: 215px;
      }
    }

    // (215 + 20) * 3 = 705 + 60 = 765
    @media screen and (max-width: ${765 - 1}px) {
      & > .creator-container > * > img {
        width: 200px;
        height: 200px;
      }

      &  > .creator-container > * > .info {
       width: 200px;
      }
    }

    // (200 + 20) * 3 = 660 + 60 = 720
    @media screen and (max-width: ${720 - 1}px) {
      & > .creator-container > * > img {
        width: 280px;
        height: 280px;
      }

      &  > .creator-container > * > .info {
       width: 280px;
      }
    }

    // (280 + 20) * 3 = 600 + 60 = 660
    @media screen and (max-width: ${660 - 1}px) { 
      & > .creator-container > * > img {
        width: 260px;
        height: 260px;
      }

      &  > .creator-container > * > .info {
        width: 260px;
      }
    }

    // (260 + 20) * 2 = 560 + 60 = 620
    @media screen and (max-width: ${620 - 1}px) { 
      & > .creator-container > * > img {
        width: 240px;
        height: 240px;
      }

      &  > .creator-container > * > .info {
        width: 240px;
      }
    }

    // (240 + 20) * 2 = 520 + 60 = 580
    @media screen and (max-width: ${580 - 1}px) { 
      & > .creator-container > * > img {
        width: 220px;
        height: 220px;
      }

      &  > .creator-container > * > .info {
        width: 220px;
      }
    }

    // (220 + 20) * 2 = 480 + 60 = 540
    @media screen and (max-width: ${540 - 1}px) {
      & > .creator-container > * > img {
        width: 200px;
        height: 200px;
      }

      &  > .creator-container > * > .info {
        width: 200px;
      }
     }

     // (200 + 20) * 2 = 440 + 60 = 500
     @media screen and (max-width: ${500 - 1}px) {
      & > .creator-container > * > img {
        width: 180px;
        height: 180px;
      }

      &  > .creator-container > * > .info {
        width: 180px;
      }
     }

     // (180 + 20) * 2 = 400 + 40 = 460
     @media screen and (max-width: ${460 - 1}px) {
      & > .creator-container {
        justify-content: center;
      }

      & > .creator-container > * > img {
        width: 250px;
        height: 250px;
      }

      &  > .creator-container > * > .info {
        width: 250px;
      }
     }

`;
